import ProjectCard from '../components/ProjectCard';

export default function Dev() {
    return (
        <>
            <div className="background">
            </div>
            <div className='content'>
                <div className='headline' id='center'>
                    <h1 className='gradientText'>Dev</h1>
                    <p>I design and build these projects myself, end-to-end — concept, design system, wireframes and prototypes, development and launch. My toolkit ranges from modern web development (React, TypeScript) to 3D interactive experiences built with Blender, Three.js, and WebGL.</p>
                </div>
                <div className='projects' id='funProjects'>
                    <ProjectCard
                        id='fun2'
                        name='The Museum of Rudeness'
                        description='An interactive 3D web experience that showcases interesting cultural nuances of rude behaviors from around the world with exhibits and games.'
                        pic='/pics/Museumrudeness.gif'
                        link='https://museum-of-rudeness.sandylee.site/'
                        background='primary-container' />
                    <ProjectCard
                        id='fun1'
                        name='Sounds of Taipei'
                        description='A delightful virtual exploration through the beautiful Taipei City with mesmerizing audios, visuals, and scrolling effects.'
                        pic='/pics/Soundstaipei.gif'
                        link='https://sounds-of-taipei.sandylee.site/'
                        background='primary-container' />
                </div>
            </div>
        </>
    )
}